import SearchFilter from "./container/SearchFilter";
import SearchTable from "./container/SearchTable";

export const QnaList = () => {
    return (
        <>
            <SearchFilter />
            <SearchTable />
        </>
    );
}